/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type GenerateTourByCompanyReportInput = {
    companyId: string;
    exportType: string;
};
export type ReportsPageGenerateTourByCompanyReportMutationVariables = {
    input: GenerateTourByCompanyReportInput;
};
export type ReportsPageGenerateTourByCompanyReportMutationResponse = {
    readonly generateTourByCompanyReport: {
        readonly fileContent: string;
        readonly fileName: string;
        readonly mimeType: string;
    };
};
export type ReportsPageGenerateTourByCompanyReportMutation = {
    readonly response: ReportsPageGenerateTourByCompanyReportMutationResponse;
    readonly variables: ReportsPageGenerateTourByCompanyReportMutationVariables;
};



/*
mutation ReportsPageGenerateTourByCompanyReportMutation(
  $input: GenerateTourByCompanyReportInput!
) {
  generateTourByCompanyReport(input: $input) {
    fileContent
    fileName
    mimeType
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateTourByCompanyReportPayload",
    "kind": "LinkedField",
    "name": "generateTourByCompanyReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportsPageGenerateTourByCompanyReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportsPageGenerateTourByCompanyReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d25258516fe261b78c3a74438566005",
    "id": null,
    "metadata": {},
    "name": "ReportsPageGenerateTourByCompanyReportMutation",
    "operationKind": "mutation",
    "text": "mutation ReportsPageGenerateTourByCompanyReportMutation(\n  $input: GenerateTourByCompanyReportInput!\n) {\n  generateTourByCompanyReport(input: $input) {\n    fileContent\n    fileName\n    mimeType\n  }\n}\n"
  }
};
})();
(node as any).hash = '48af08af020abda280558b262c267874';
export default node;
